<template>
   <div class="dyn-filter datePicker">
      <ods-date-picker @change="dateCustom" type="month" v-model="dateSelected" :picker-options="pickerOptions" ref="datePicker"></ods-date-picker>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
export default {
  name: 'datePicker',
  props: {
    field: { type: Object, required: true }
  },
  data: function () {
    return {
      dateSelected: [],
      dateNoParse: false,
      today: this.$moment().format('YYYYMM').toString(),
      sixMonthsAgo: this.$moment().subtract(6, 'months').format('YYYYMM').toString(),
      yearAgo: this.$moment().subtract(1, 'year').format('YYYYMM').toString()
    }
  },
  computed: {
    ...mapGetters({
      getGlobalFilters: 'getGlobalFilters'
    }),

    filters () {
      return this.$parent.filters
    },

    activeFilter () {
      var data = this.getGlobalFilters
      return data.filter(x => x.id === this.field.id).map(y => y.filter.activeFilter)[0]
    },
    // OPTIONS FOR DATEPICKER
    pickerOptions () {
      var that = this
      var options = {}
      options.disabledDate = function (time) {
        if (time.getTime() > Date.now()) {
          return true
        } else {
          if (time.getTime() < that.$moment().subtract(1, 'year').valueOf()) {
            return true
          } else {
            return false
          }
        }
      }

      options.shortcuts = [{
        text: 'Últimos 6 meses',
        onClick (picker) {
          picker.$emit('pick', that.$moment().subtract(5, 'months').valueOf())
          that.dateHandler('6')
        }
      }, {
        text: 'Últimos 12 meses',
        onClick (picker) {
          picker.$emit('pick', that.$moment().subtract(11, 'months').valueOf())
          that.dateHandler('12')
        }
      }]

      return options
    }
  },
  methods: {
    ...mapActions([
      'filterDataFilter',
      'sendFilter',
      'updateGlobalFilters'
    ]),
    // INIT FIELD AND CONNECTIONS
    handleField () {
      console.log('handleField() |--> ', this.field.id)
      // assign value, persistence filters
      if (this.field.filter.activeFilter !== '' && this.field.filter.activeFilter !== null) {
        this.dateNoParse = true
        this.dateSelected = this.$moment(this.field.filter.activeFilter, 'YYYYMM').toDate()
      }

      // if has value and has related fields make filter between fields
      if (this.field.schema.filterTo.length > 0) {
        this.handleFilterFields()
        this.handleEnableDisableFields()
      }
    },

    // MAKE FILTER BETWEEN FIELDS
    handleFilterFields () {
      console.log('handleFilterFields() |--> ', this.field.id)
      if (this.field.schema.filterTo && this.field.schema.filterTo.length > 0) {
        var items = this.field.schema.filterTo
        for (let i = 0; i < items.length; i++) {
          console.log('|--> filter to update: ', items[i])
          this.filterDataFilter({ id: items[i], field: this.field.filter.field, value: this.dateSelected })
        }
      }
    },

    // HANDLE ENABLE OR DISABLE RELATED FIELDS
    handleEnableDisableFields () {
      console.log('handleEnableDisableFields() |--> ', this.field.id)
      if (this.field.schema.filterTo.length > 0) {
        var fields = this.field.schema.filterTo
        var disabled = false
        for (let i = 0; i < fields.length; i++) {
          if (this.field.schema.multi) {
            // multiple-value field
            disabled = this.field.filter.activeFilter.length === 0
          } else {
            // single-value field
            disabled = this.field.filter.activeFilter === ''
          }
          // apply disabled state
          this.updateGlobalFilters({ id: fields[i], key: 'schema', elem: 'isDisabled', data: disabled })
          console.log('  |--> Field ', fields[i], 'disabled: ', disabled)
        }
      }
    },

    // DATE HANDLER BETWEEN CUSTOM, 6 AND 12 MONTHS
    dateHandler (value) {
      this.updateGlobalFilters({ id: this.field.id, key: 'schema', elem: 'dateManager', data: value })
    },
    // DATE PARSER AUX
    dateParser (value) {
      const date = new Date(value)
      let month = (date.getMonth() + 1).toString()
      const year = date.getFullYear().toString()
      month = month.length === 1 ? `0${month}` : month
      return parseInt(year + month)
    },

    // DATECUSTOM: @change
    // filter other selectors if needed
    // |--> filter real data
    // send Filter and Update activeFilter property to generate persistence on filters on dashboard load.
    dateCustom (value) {
      // console.log('dateCustom(' + this.field.id + ') |--> Value: ', value, 'field: ', this.field.id, ' this field filter others: ', this.field.schema.filterTo, ' dateManager: ', this.field.schema.dateManager)

      // dateManager
      if (typeof value !== 'number') {
        this.updateGlobalFilters({ id: this.field.id, key: 'schema', elem: 'dateManager', data: 'custom' })
      }

      // check filters
      this.handleFilterFields()

      // Enable/disable other fields
      this.handleEnableDisableFields()

      // parse Data before send Filter
      if (this.dateNoParse) { this.dateNoParse = false; return false } // not parse if date is activeFilter, then send filter initially
      var dateParsed = 0
      if (value === null) {
        this.sendFilter({ filterId: this.field.id, value: '', op: 'between' })
        this.updateGlobalFilters({ id: this.field.id, key: 'filter', elem: 'activeFilter', data: '' })
      } else {
        if (this.field.schema.dateManager === 'custom') {
          dateParsed = this.dateParser(new Date(value))
          this.sendFilter({ filterId: this.field.id, value: dateParsed + ' and ' + dateParsed, op: 'between' })
          this.updateGlobalFilters({ id: this.field.id, key: 'filter', elem: 'activeFilter', data: dateParsed })
        } else {
          const now = new Date()
          dateParsed = this.dateParser(new Date(value))
          this.updateGlobalFilters({ id: this.field.id, key: 'filter', elem: 'activeFilter', data: dateParsed })
          var dateNowParsed = this.dateParser(now)
          if (this.field.schema.dateManager === '6') {
            this.sendFilter({ filterId: this.field.id, value: dateParsed + ' and ' + dateNowParsed, op: 'between' })
            this.updateGlobalFilters({ id: this.field.id, key: 'schema', elem: 'dateManager', data: 6 })
          }
          if (this.field.schema.dateManager === '12') {
            this.sendFilter({ filterId: this.field.id, value: dateParsed + ' and ' + dateNowParsed, op: 'between' })
            this.updateGlobalFilters({ id: this.field.id, key: 'schema', elem: 'dateManager', data: 12 })
          }
        }
      }
    }
  },
  watch: {
    activeFilter: {
      deep: true,
      handler () {
        console.log('ActiveFilter for ' + this.field.id + ' was changed...')
      }
    }
  },
  mounted () {
    // READ FIELD INFO AND INIT THE FIELD OR MAKE OTHER ACTIONS (enable,disabled,visible,...) TO OTHER FIELDS
    this.handleField()
  }
}
</script>
